import "./App.css";
import FadeExample from "./FadeExample";


function App() {
  return (
    <div className="main">
    <FadeExample/>
    </div>
  );
}

export default App;
